(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('promo-bar')) return;

    class PromoBar extends HTMLElement {
      constructor() {
        super();
        this.currentSlide = 0;
        this.slides = [];
        this.timers = [];
        this.rotationTimer = null;
        this.countdownTimer = null;
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.promo-bar__slide'));
        this.timers = Array.from(this.querySelectorAll('.promo-bar__timer'));

        const rotationMs = (parseInt(this.dataset.rotationInterval, 10) || 6) * 1000;

        if (this.slides.length > 1) this.startRotation(rotationMs);
        if (this.timers.length) this.startCountdown();
      }

      disconnectedCallback() {
        clearInterval(this.rotationTimer);
        clearInterval(this.countdownTimer);
      }

      startRotation(intervalMs) {
        this.rotationTimer = setInterval(() => {
          this.slides[this.currentSlide].classList.remove('is-active');
          this.currentSlide = (this.currentSlide + 1) % this.slides.length;
          this.slides[this.currentSlide].classList.add('is-active');
        }, intervalMs);
      }

      startCountdown() {
        const pad = (n) => (n < 10 ? '0' : '') + n;

        const update = () => {
          const now = new Date();
          const ams = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));

          this.timers.forEach((el) => {
            const targetHour = parseInt(el.dataset.countdownHour, 10) || 0;
            const targetMinute = parseInt(el.dataset.countdownMinute, 10) || 0;

            let target = new Date(ams);
            target.setHours(targetHour, targetMinute, 0, 0);
            if (ams >= target) target.setDate(target.getDate() + 1);

            const uh = el.dataset.unitH || 'u';
            const um = el.dataset.unitM || 'm';
            const us = el.dataset.unitS || 's';

            const diff = target - ams;
            if (diff <= 0) {
              el.textContent = '00' + uh + ' 00' + um + ' 00' + us;
              return;
            }

            const h = Math.floor(diff / 3600000);
            const m = Math.floor((diff % 3600000) / 60000);
            const s = Math.floor((diff % 60000) / 1000);
            el.textContent = pad(h) + uh + ' ' + pad(m) + um + ' ' + pad(s) + us;
          });
        };

        update();
        this.countdownTimer = setInterval(update, 1000);
      }
    }

    customElements.define('promo-bar', PromoBar);
  })();

  } catch(e) { console.error(e); }
})();
})();
